import { TAutoSavingSegmentData, TServerSegment, TUpdatingSegmentData } from '@/shared/types/Editor';

export type ChangedDataKey = 'dst' | 'end' | 'selected_translation_variant' | 'speaker' | 'src' | 'start';
export type RevertedSegmentData = { id: TUpdatingSegmentData['id'] } & Partial<Pick<TServerSegment, ChangedDataKey>>;

export const CHANGED_DATA_KEYS: ChangedDataKey[] = [
  'dst',
  'end',
  'selected_translation_variant',
  'speaker',
  'src',
  'start',
];

// Keys the user changed locally that are NOT already superseded by a newer queued auto-save —
// i.e. the only fields safe to revert to the server value when a save fails.
export const getUnsupersededChangedKeys = (
  changedData: TUpdatingSegmentData,
  queuedData?: TAutoSavingSegmentData,
): ChangedDataKey[] => {
  return CHANGED_DATA_KEYS.filter((key) => key in changedData && (!queuedData || !(key in queuedData)));
};

// Builds the patch that reverts the given keys back to their last server-known values.
export const getRevertedSegmentData = (
  segmentId: TUpdatingSegmentData['id'],
  changedKeys: ChangedDataKey[],
  segmentFromServer?: TServerSegment,
): null | RevertedSegmentData => {
  if (!segmentFromServer) {
    return null;
  }

  const revertedSegmentData: RevertedSegmentData = { id: segmentId };

  changedKeys.forEach((key) => {
    Object.assign(revertedSegmentData, { [key]: segmentFromServer[key] });
  });

  return revertedSegmentData;
};
